export const businessData = [
  {
    imageUrl: require("../../../assets/images/business1.png"),
    name: "Name",
    position: "Co Founder",
  },
  {
    imageUrl: require("../../../assets/images/business2.png"),
    name: "Name",
    position: "Co Founder",
  },
  {
    imageUrl: require("../../../assets/images/business3.png"),
    name: "Name",
    position: "Co Founder",
  },
  {
    imageUrl: require("../../../assets/images/business4.png"),
    name: "Name",
    position: "Co Founder",
  },
  {
    imageUrl: require("../../../assets/images/business5.png"),
    name: "Name",
    position: "Co Founder",
  },
  {
    imageUrl: require("../../../assets/images/business6.png"),
    name: "Name",
    position: "Co Founder",
  },
];

export const reviewData = [
  {
    key: 5,
    percent: 75,
    points: 982,
  },
  {
    key: 4,
    percent: 16,
    points: 205,
  },
  {
    key: 3,
    percent: 5,
    points: 65,
  },
  {
    key: 2,
    percent: 1,
    points: 17,
  },
  {
    key: 1,
    percent: 3,
    points: 46,
  },
];
